import Vue, { PropType } from 'vue';
import IconBase from '../icon';
import { IconProps, SVGJson } from '../utils/types';
import useSizeProps from '../utils/use-size-props';

const element: SVGJson = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M23 21H1V3H23V21ZM6.5 8V10H9V14H5V16H9.59961C9.84165 16 10.1112 15.9492 10.3555 15.8184C10.558 15.7097 10.9998 15.3914 11 14.7861V8H6.5ZM13 16H15V13.2139H17.5C18.1782 13.2139 18.9998 12.7139 19 11.7861V9.42871C19 8.50067 18.1783 8 17.5 8H13V16ZM17 11.2139H15V10H17V11.2139Z"}}]};

const JapaneseRectangleFilled = Vue.extend<IconProps>({
  name: 'JapaneseRectangleFilledIcon',
  functional: true,
  props: {
    size: {
      type: String,
    },
    onClick: {
      type: Function as PropType<IconProps['onClick']>,
    },
    fillColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeWidth: {
      type: Number,
      default: 2
    }
  },
  render(createElement, context) {
    const { props, data } = context;
    const { size, ...otherProps } = props;

    const { className, style } = useSizeProps(size);
    const fullProps = {
      ...otherProps || {},
      id: 'japanese-rectangle-filled',
      icon: element,
      staticClass: className,
      style,
    };
    data.props = fullProps;
    return createElement(IconBase, data);
  },
});

export default JapaneseRectangleFilled;
